module.exports = __webpack_public_path__ + "static/postman-545fcd48f574066c3affdf85dd0b3ea0.png";